import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { GLOBAL } from 'src/app/services/global';
//const nombreMuni = GLOBAL.nombreMuni;
var Formulario11Component = /** @class */ (function () {
    function Formulario11Component() {
        this.htmlcanvas = html2canvas;
        this.nombreMuni = GLOBAL.nombreMuni;
        this.region = GLOBAL.region;
        //listas
        this.perm_pri = [];
        this.ampliaciones = [];
        this.recep = [];
        this.pages = [1, 2, 3];
        this.probando_archivos = {
            "name": "1.1",
            "archivos": [
                { "name": "Fotocopia Certificado de Informaciones Previas Vigente", "obligatorio": true, "ready": false },
                { "name": "Fotocopia de Patente al dia del o los Profesional (es)Competente(s)", "obligatorio": true, "ready": false },
                { "name": "Croquis de ubicacion o croquis de emplazamiento, a escala.", "obligatorio": true, "ready": false },
                { "name": "Solicitud de Permiso de Obra Menor Firmada y Escaneada", "obligatorio": true, "ready": false }
            ]
        };
        //ANTECEDENTES
        if (JSON.parse(localStorage.getItem("antecedentes")).length > 0) {
            this.antecedentes = JSON.parse(localStorage.getItem("antecedentes"));
        }
        else {
            localStorage.setItem("antecedentes", JSON.stringify([]));
            this.antecedentes = [{ tipo_permiso: '', permiso: '', numero: 0, fecha: null, superficie: 0 }];
        }
        if (this.antecedentes.length > 0) {
            for (var i = 0; i < this.antecedentes.length; i++) {
                if (this.antecedentes[i].tipo_permiso == "Permiso Primitivo") {
                    this.perm_pri.push(this.antecedentes[i]);
                }
                else if (this.perm_pri.length == 0 && this.antecedentes.length == (i + 1)) {
                    this.perm_pri = [{ tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null }];
                }
                if (this.antecedentes[i].tipo_permiso == "Modificaciones y Ampliaciones") {
                    this.ampliaciones.push(this.antecedentes[i]);
                }
                else if (this.ampliaciones.length == 0 && this.antecedentes.length == (i + 1)) {
                    this.ampliaciones = [{ tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null },
                        { tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null },
                        { tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null }];
                }
                if (this.antecedentes[i].tipo_permiso == "Recepcion") {
                    this.recep.push(this.antecedentes[i]);
                }
                else if (this.recep.length == 0 && this.recep.length == (i + 1)) {
                    this.recep = [{ tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null },
                        { tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null },
                        { tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null },
                        { tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null }];
                }
            }
            if (this.ampliaciones.length > 0 && this.ampliaciones.length < 3) {
                for (var x = this.ampliaciones.length; x < 3; x++) {
                    this.ampliaciones.push({ tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null });
                }
            }
            if (this.recep.length > 0 && this.recep.length < 4) {
                for (var x = this.recep.length; x < 4; x++) {
                    this.recep.push({ tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null });
                }
            }
        }
        else {
            this.perm_pri = [{ tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null },];
            this.ampliaciones = [{ tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null },
                { tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null },
                { tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null }];
            this.recep = [{ tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null },
                { tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null },
                { tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null },
                { tipo_permiso: '', permiso: '', numero: null, fecha: null, superficie: null }];
        }
        this.ngAfterContentInit();
    }
    Formulario11Component.prototype.check_event = function (event) {
        console.log(event);
        console.log(event.target.defaultValue);
        var igual = false;
        for (var i = 0; i < this.probando_archivos.archivos.length; i++) {
            if (this.probando_archivos.archivos[i].name == event.target.defaultValue) {
                igual = true;
                if (!event.target.checked) {
                    this.probando_archivos.archivos.splice(i, 1);
                }
            }
        }
        if (!igual) {
            this.probando_archivos.archivos.push({ "name": event.target.defaultValue, "obligatorio": true, "ready": false });
        }
        console.log(this.probando_archivos);
        localStorage.setItem("archivos2", this.probando_archivos);
    };
    Formulario11Component.prototype.ngAfterContentChecked = function () {
        this.ngAfterContentInit();
    };
    Formulario11Component.prototype.ngAfterContentInit = function () {
        //TIPO SOLICITUD
        //console.log('localStorage.getItem("tipo_solicitud")', localStorage.getItem("tipo_solicitud"))
        if (JSON.parse(localStorage.getItem("tipo_solicitud"))) {
            if (JSON.parse(localStorage.getItem("tipo_solicitud")).length > 0) {
                this.tipo_solicitud = JSON.parse(localStorage.getItem("tipo_solicitud"));
            }
            else {
                localStorage.setItem("tipo_solicitud", JSON.stringify([]));
                this.tipo_solicitud = [{ "optradio": { "AMPLIACIÓN MENOR A 100 M2": false, "MODIFICACIÓN": false, "ART 6 2 9 OGUC": false } }];
            }
        }
        //CIP
        if (JSON.parse(localStorage.getItem("cip"))) {
            if (JSON.parse(localStorage.getItem("cip")).length > 0) {
                this.cip = JSON.parse(localStorage.getItem("cip"));
            }
            else {
                localStorage.setItem("cip", JSON.stringify([]));
                this.cip = [{ certcip: '', fecha_cip: null }];
            }
        }
        //REGISTRO
        if (JSON.parse(localStorage.getItem("registro_bienes"))) {
            if (JSON.parse(localStorage.getItem("registro_bienes")).length > 0) {
                this.registro_bienes = JSON.parse(localStorage.getItem("registro_bienes"));
            }
            else {
                localStorage.setItem("registro_bienes", JSON.stringify([]));
                this.registro_bienes = [{ inscrito: '', numero: '', anio: '', bienes: '' }];
            }
        }
        //PROPIEDAD
        if (JSON.parse(localStorage.getItem("propiedad"))) {
            if (JSON.parse(localStorage.getItem("propiedad")).length > 0) {
                this.propiedad = JSON.parse(localStorage.getItem("propiedad"));
            }
            else {
                localStorage.setItem("propiedad", JSON.stringify([]));
                this.propiedad = [{ rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa: '', direc_complemento: '', direc_compl_num: '', loteo: '', manzana: '', plano: '', recordId: '' }];
            }
        }
        //PROPIETARIOS
        if (JSON.parse(localStorage.getItem("propietarios"))) {
            if (JSON.parse(localStorage.getItem("propietarios")).length > 0) {
                this.propietarios = JSON.parse(localStorage.getItem("propietarios"));
            }
            else {
                localStorage.setItem("propietarios", JSON.stringify([]));
                this.propietarios = [{ rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' }];
            }
        }
        //REPRESENTANTE
        if (JSON.parse(localStorage.getItem("representantes"))) {
            if (JSON.parse(localStorage.getItem("representantes")).length > 0) {
                this.representantes = JSON.parse(localStorage.getItem("representantes")); //no es obligatorio pero si tiene informacion debe estar permiso_notariado obligatoriamente
            }
            else {
                localStorage.setItem("representantes", JSON.stringify([]));
                this.representantes = [{ rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' }];
            }
        }
        //PERMISO NOTARIADO
        if (JSON.parse(localStorage.getItem("permiso_notariado"))) {
            if (JSON.parse(localStorage.getItem("permiso_notariado")).length > 0) {
                this.permiso_notariado = JSON.parse(localStorage.getItem("permiso_notariado"));
            }
            else {
                localStorage.setItem("permiso_notariado", JSON.stringify([]));
                this.permiso_notariado = [{ acreditacion: '', fecha: null, escritura: null, notario: '' }];
            }
        }
        //DECLARACION
        if (JSON.parse(localStorage.getItem("declaracion"))) {
            if (JSON.parse(localStorage.getItem("declaracion")).length > 0) {
                this.declaracion = JSON.parse(localStorage.getItem("declaracion"));
            }
            else {
                localStorage.setItem("declaracion", JSON.stringify([]));
                this.declaracion = [{ plano: '', denominado: '', elaborado: '', profesion: '' }];
            }
        }
        //ARQUITECTOS
        if (JSON.parse(localStorage.getItem("arquitectos"))) {
            if (JSON.parse(localStorage.getItem("arquitectos")).length > 0) {
                this.arquitectos = JSON.parse(localStorage.getItem("arquitectos"));
            }
            else {
                localStorage.setItem("arquitectos", JSON.stringify([]));
                this.arquitectos = [{ rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', recordId: '' }];
            }
        }
        //EMPRESAS
        if (JSON.parse(localStorage.getItem("empresas"))) {
            if (JSON.parse(localStorage.getItem("empresas")).length > 0) {
                this.empresas = JSON.parse(localStorage.getItem("empresas"));
            }
            else {
                localStorage.setItem("empresas", JSON.stringify([]));
                this.empresas = [{ rut: '', nombre: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' }];
            }
        }
        //CONSTRUCTORA
        if (JSON.parse(localStorage.getItem("constructora"))) {
            if (JSON.parse(localStorage.getItem("constructora")).length > 0) {
                this.constructora = JSON.parse(localStorage.getItem("constructora"));
            }
            else {
                localStorage.setItem("constructora", JSON.stringify([]));
                this.constructora = [{ rut: '', nombre: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', recordId: '' }];
            }
        }
        //CONSTRUCTORES 
        if (JSON.parse(localStorage.getItem("constructores"))) {
            if (JSON.parse(localStorage.getItem("constructores")).length > 0) {
                this.constructores = JSON.parse(localStorage.getItem("constructores"));
            }
            else {
                localStorage.setItem("constructores", JSON.stringify([]));
                this.constructores = [{ rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', recordId: '' }];
            }
        }
        //INDEPENDIENTE
        if (JSON.parse(localStorage.getItem("independiente"))) {
            if (JSON.parse(localStorage.getItem("independiente")).length > 0) {
                this.independiente = JSON.parse(localStorage.getItem("independiente"));
            }
            else {
                localStorage.setItem("independiente", JSON.stringify([]));
                this.independiente = [{ rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', registro: '', categoria: '', recordId: '' }];
            }
        }
        //INFORME
        if (JSON.parse(localStorage.getItem("informe"))) {
            if (JSON.parse(localStorage.getItem("informe")).length > 0) {
                this.informe = JSON.parse(localStorage.getItem("informe"));
            }
            else {
                localStorage.setItem("informe", JSON.stringify([]));
                this.informe = [{ infradio: '', num_informe: 0, fech_informe: null }];
            }
        }
        //ANTECEDENTES
        if (JSON.parse(localStorage.getItem("antecedentes"))) {
            if (JSON.parse(localStorage.getItem("antecedentes")).length > 0) {
                this.antecedentes = JSON.parse(localStorage.getItem("antecedentes"));
            }
            else {
                localStorage.setItem("antecedentes", JSON.stringify([]));
                this.antecedentes = [{ tipo_permiso: '', permiso: '', numero: 0, fecha: null, superficie: 0 }];
            }
        }
        //PROYECTO
        if (JSON.parse(localStorage.getItem("proyecto"))) {
            if (JSON.parse(localStorage.getItem("proyecto")).length > 0) {
                this.proyecto = JSON.parse(localStorage.getItem("proyecto"));
            }
            else {
                localStorage.setItem("proyecto", JSON.stringify([]));
                this.proyecto = [{ destinos: '', superf_existente: '', superf_proyectada: '', npisos: '', superf_terreno: '', coef_construct: '', ocupadooc: '', proyectadooc: '', Art121: '', Art122: '', Art123: '', Art124: '', Ley19537: '', Otro: '', uso_publico: '', edif_nac: '' }];
            }
        }
        //PLAZO
        if (JSON.parse(localStorage.getItem("plazo"))) {
            if (JSON.parse(localStorage.getItem("plazo")).length > 0) {
                this.plazo = JSON.parse(localStorage.getItem("plazo"));
            }
            else {
                localStorage.setItem("plazo", JSON.stringify([]));
                this.plazo = [{ plazo: '' }];
            }
        }
    };
    Formulario11Component.prototype.captureScreen = function () {
        var _this = this;
        var pdf = new jspdf('p', 'mm', 'a4');
        this.htmlcanvas(document.getElementById("page1")).then(function (canvas) {
            var contentDataURL = canvas.toDataURL('image/png');
            pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297);
        });
        this.htmlcanvas(document.getElementById("page2")).then(function (canvas) {
            var contentDataURL = canvas.toDataURL('image/png');
            pdf.addPage();
            pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297);
        });
        this.htmlcanvas(document.getElementById("page3")).then(function (canvas) {
            var contentDataURL = canvas.toDataURL('image/png');
            pdf.addPage();
            pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297);
        });
        setTimeout(function () {
            pdf.save(_this.propietarios[0].rut + '.pdf');
            // pdf.save('prueba.pdf')
        }, 6000);
    };
    return Formulario11Component;
}());
export { Formulario11Component };
